import { useState } from 'react';

import { useAuth } from '../hooks/useAuth';
import { BRAND_LOGO } from './GreetingOverlay';

// Bumped only if there is ever another rename worth interrupting people for.
const SEEN_KEY = 'whoworks:rebrand-onvi-works';

/**
 * The rename reaches nobody who already has the app on their home screen: iOS
 * keeps the icon and the name from the moment it was installed. So it is said
 * once, to each person, and then never again.
 */
export const RebrandNotice = () => {
  const { user } = useAuth();
  const storageKey = user ? `${SEEN_KEY}:${user.id}` : null;
  const [open, setOpen] = useState(() =>
    storageKey ? localStorage.getItem(storageKey) !== 'seen' : false,
  );

  if (!open || !user || !storageKey) {
    return null;
  }

  const dismiss = () => {
    localStorage.setItem(storageKey, 'seen');
    setOpen(false);
  };

  return (
    // Above the greeting: this is the one thing that must not be missed.
    <div className="sheet-scrim z-[80]" role="presentation">
      <div className="sheet max-w-md text-center" role="dialog" aria-modal="true" aria-label="Rebranding">
        <div className="mx-auto mb-4 h-1.5 w-10 rounded-full bg-black/10 dark:bg-white/15 sm:hidden" />

        <img src={BRAND_LOGO} alt="ONVI WORKS" className="mx-auto h-9 w-auto" />

        <h2 className="mt-5 font-display t-title">
          Appka sa premenovala
        </h2>
        <p className="mt-2 text-[15px] leading-relaxed text-slate-500 dark:text-slate-400">
          Z WhoWorks je ONVI WORKS. Ak ju máš na ploche, zmaž ju odtiaľ a pridaj nanovo —
          ikona aj názov sa uložia pri inštalácii, takže inak ti ostane tá stará.
        </p>

        <button type="button" className="btn-primary mt-6 w-full" onClick={dismiss}>
          Rozumiem
        </button>
      </div>
    </div>
  );
};
